import { createAction } from "chalet-shared";

export const actionCreators = {
    loadAvatarRequested: createAction("LOAD_AVATAR_REQUESTED", (url: string) => ({
        type: "LOAD_AVATAR_REQUESTED",
        url,
    })),
    loadAvatarStarted: createAction("LOAD_AVATAR_STARTED", (url: string) => ({
        type: "LOAD_AVATAR_STARTED",
        url,
    })),
    loadAvatarSuccess: createAction(
        "LOAD_AVATAR_SUCCESS",
        (url: string, height: number, width: number) => ({
            type: "LOAD_AVATAR_SUCCESS",
            url,
            height,
            width,
        })
    ),
    loadAvatarFailure: createAction("LOAD_AVATAR_FAILURE", (url: string) => ({
        type: "LOAD_AVATAR_FAILURE",
        url,
    })),
};
